module.exports = __webpack_public_path__ + "c65c0e85b8b81a0421f0bb444203d73d.png";